import { SURVEY_TYPES } from "../js/lists";
import { formatDateTime } from "../utils/date";
import { DATE_FULL_MONTH_DAY_YEAR } from "../js/constants";

export function mapSurveyDataToPdfFields(fieldNames, state, props = null) {
  // Map survey data to PDF form fields based on field names
  const mappedValues = {};

  // Common field name mappings
  const fieldMappings = {
    ccName: ["Company Name"],
    ccAddress: ["Company Address"],
    ccContactName: ["Company Liason - NAME"],
    ccContactPhone: ["Company Liason - PHONE -Day"],
    project_name: ["Project Name"],
    project_street_name: ["Project Address"],
    project_l1_name: ["Project Liason PRIMARY - NAME"],
    project_l1_main_telephone_number: ["Project Liason PRIMARY - PHONE -Day"],
    project_l2_name: ["Project Liason SECONDARY- NAME"],
    project_l2_main_telephone_number: ["Project Liason SECONDARY - PHONE -Day"],
    visitdate: ["ANTICIPTATED SERVICE REQUIREMENT END DATE"],
    request_type: ["First site survey", "Multiple Cranes", "Second Site Survey", "Annual Site Survey"],
    cranes: ["CRANE 1 ID", "CRANE 2 ID", "CRANE 3 ID", "CRANE 4 ID"],
  };

  // Try to match field names with survey data
  const surveyTypes = Object.keys(SURVEY_TYPES);
  fieldNames.forEach((fieldName) => {
    // Check if the field name exists directly in the state
    if (state.hasOwnProperty(fieldName)) {
      mappedValues[fieldName] = state[fieldName] || "";
      return;
    }

    // Try to match with our field mappings
    for (const [stateKey, possibleFieldNames] of Object.entries(fieldMappings)) {
      if (possibleFieldNames.some((name) => fieldName.toLowerCase().includes(name.toLowerCase()))) {
        // Handle company/cost center fields from props if available
        if (stateKey === "ccName" && props && props.cc) {
          mappedValues[fieldName] = props.cc.entity_name || "";
        } else if (stateKey === "ccAddress" && props && props.cc && props.cc.address) {
          const { city, compliment, number, postalcode, province, street } = props.cc.address;
          if (props.cc.id) {
            mappedValues[fieldName] =
              `${number} ${street}` +
              (compliment ? ` Suite: ${compliment} ` : ` `) +
              `${city} ${postalcode} ${province}`;
          }
        } else if (stateKey === "ccContactName" && props && props.cc) {
          mappedValues[fieldName] = props.cc.contact_name || "";
        } else if (stateKey === "ccContactPhone" && props && props.cc) {
          mappedValues[fieldName] = props.cc.main_telephone_number || "";
        } else if (stateKey === "project_street_name" && state[stateKey]) {
          mappedValues[
            fieldName
          ] = `${state.project_street_number} ${state.project_street_name} ${state.project_city} ${state.project_postal_code} ${state.project_province}`;
        } else if (stateKey === "project_l1_main_telephone_number" && state[stateKey]) {
          mappedValues[fieldName] =
            state.project_l1_main_telephone_number +
            (state.project_l1_main_telephone_ext ? ` ext: ${state.project_l1_main_telephone_ext}` : "");
        } else if (stateKey === "project_l2_main_telephone_number" && state[stateKey]) {
          mappedValues[fieldName] =
            state.project_l2_main_telephone_number +
            (state.project_l2_main_telephone_ext ? ` ext: ${state.project_l2_main_telephone_ext}` : "");
        } else if (stateKey === "visitdate" && state[stateKey]) {
          mappedValues[fieldName] = formatDateTime(state[stateKey], DATE_FULL_MONTH_DAY_YEAR);
        } else if (stateKey === "request_type" && state[stateKey]) {
          // Check if the current field name corresponds to a survey type and set it to true only when it matches
          const surveyTypeIndex = possibleFieldNames.indexOf(fieldName);
          if (surveyTypeIndex !== -1 && surveyTypes[surveyTypeIndex]) {
            // Set to true only if this field's survey type matches the selected request_type
            mappedValues[fieldName] = state[stateKey] === surveyTypes[surveyTypeIndex];
          } else {
            // For fields that aren't directly mapping to survey types
            possibleFieldNames.forEach((name, idx) => {
              if (fieldName.toLowerCase().includes(name.toLowerCase())) {
                mappedValues[fieldName] = state[stateKey] === surveyTypes[idx];
              }
            });
          }
        } else if (stateKey === "cranes" && state[stateKey]) {
          const craneIndex = possibleFieldNames.indexOf(fieldName);
          if (craneIndex !== -1 && state.cranes[craneIndex]) {
            mappedValues[fieldName] = state.cranes[craneIndex].name || "";
          }
        } else {
          mappedValues[fieldName] = state[stateKey] || "";
        }
        break;
      }
    }
  });
  return mappedValues;
}
